const defaultLanguages = ['fr', 'en'];

export default defaultLanguages;
